import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const BucketFragment = gql`
  fragment BucketFragment on Bucket {
    id
    bucketId
    description
    
    exts
    size
    minFileSize
    maxFileSize

    status

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query BucketGet($bucketId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        buckets {
          id
          get(bucketId: $bucketId) {
            ...BucketFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BucketFragment}
`;

// Ranked full-text search. Its own query rather than a variant of `list`:
// SearchInput carries a query string and no ordering, because results come back
// in score order. See docs/search.md.
export const search = gql`
  query BucketSearch($input: SearchInput!) {
    viewer {
      id
      account {
        id
        buckets {
          id
          search(input: $input) {
            id
            last
            items {
              ...BucketFragment
            }
          }
        }
      }
    }
  }
  ${BucketFragment}
`;

export const list = gql`
  query BucketList($input: ListInput) {
    viewer {
      id
      account {
        id
        buckets {
          id
          list(input: $input) {
            id
            last
            items {
              ...BucketFragment
            }
          }
        }
      }
    }
  }
  ${BucketFragment}
`;




export const create = gql`
  mutation BucketNew($input: BucketInputCreate!) {
    viewer {
      account {
        buckets {
          create(input: $input) {
            ...BucketFragment
          }
        }
      }
    }
  }
  ${BucketFragment}
`;



export const edit = gql`
  mutation BucketEdit(
    $bucketId: String!
    $input: BucketInputUpdate!
  ) {
    viewer {
      account {
        buckets {
          get(bucketId: $bucketId) {
            update(input: $input) {
              ...BucketFragment
            }
          }
        }
      }
    }
  }
  ${BucketFragment}
`;


export const remove = gql`
  mutation BucketRemove($bucketId: String!) {
    viewer {
      account {
        buckets {
          get(bucketId: $bucketId) {
            remove 
          }
        }
      }
    }
  }

`;




export const update = ({ bucketId }) => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`buckets/queries`)) {
      cache.data.delete(key);
    }
  });
};
